import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'navy' | 'lime' | 'shell';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'navy',
  title,
  lead,
  align = 'center',
  tone = 'dark',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  const titleColor = tone === 'dark' ? 'text-ink' : 'text-shell';
  const leadColor = tone === 'dark' ? 'text-stone' : 'text-shell/75';
  return <div className={`${alignment} ${className}`} data-id="element-167" data-mp="1shha201bmbx">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-168" data-mp="6slof1f1z4ph">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[1.85rem] font-extrabold leading-[1.1] sm:text-4xl lg:text-[2.6rem] ${titleColor} ${eyebrow ? 'mt-4' : ''}`} data-id="element-169" data-mp="uj7tqkxoaavs">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed ${leadColor} ${align === 'center' ? 'mx-auto max-w-readable' : 'max-w-readable'}`} data-id="element-170" data-mp="zc0w525o574p">
          {lead}
        </p> : null}
    </div>;
}